<template>
  <app>
    <template v-slot:languageSelection>
      <language-selection />
    </template>
    <template v-slot:content>
      <home />
    </template>
  </app>
</template>

<script>
const App = () => import(/* webpackChunkName: "HomePage" */ "@/App.vue");
const LanguageSelection = () =>
  import(/* webpackChunkName: "HomePage" */ "@/components/Global/LanguageSelection.vue");
const Home = () => import(/* webpackChunkName: "HomePage" */ "@/views/Home.vue");

export default {
  name: "HomeApp",
  components: {
    App,
    LanguageSelection,
    Home
  }
};
</script>
